<template>
	<svg t="1681981921429" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5891" width="100" height="100"><path d="M0 192l0 576 1024 0L1024 192 0 192zM960 704 64 704 64 256l896 0L960 704zM256 448 128 448 128 384l128 0L256 448zM448 448 320 448 320 384l128 0L448 448zM640 448 512 448 512 384l128 0L640 448zM256 576 128 576 128 512l128 0L256 576zM448 576 320 576 320 512l128 0L448 576zM640 576 512 576 512 512l128 0L640 576zM768 448c0-35.328 28.672-64 64-64s64 28.672 64 64-28.672 64-64 64S768 483.328 768 448z" p-id="5892"></path></svg>
</template>
<script>
	export default {
		name : "icon-uid",
	}
</script>